module.exports = __webpack_public_path__ + "img/381.85af528c.jpg";